const contentPaths = {
    'quickstart': './content/welcome/welcome.md',
    'how-it-works': './content/guides/101/how-it-works.md',
    'supported-assets': './content/guides/101/supported-assets.md',
    'glossary': './content/guides/101/glossary.md',
    'faq': './content/guides/101/faq.md',
    'payment-lifecycle': './content/guides/payments/lifecycle.md',
    'core-objects': './content/guides/payments/core-objects.md',
    'payment-object': './content/guides/payments/payment-object.md',
    'payment-instructions': './content/guides/payments/payment-instructions.md',
    'webhooks': './content/guides/payments/webhooks.md',
    'testing-crypto': './content/guides/sandbox/crypto-testing.md',
    'testing-sandbox': './content/guides/sandbox/sandbox-guide.md',
    'error-handling': './content/guides/sandbox/error-handling.md',
    'go-live': './content/guides/production/go-live.md',
    'integration-overview': './content/guides/integration/integration-overview.md',
    'sandbox-integration': './content/guides/integration/sandbox-integration.md',
    'production-integration': './content/guides/integration/production-integration.md',
    'api-reference': '/content/reference/api-reference.md',
    'oauth': '/content/reference/oauth.md',
    'payments': '/content/reference/payments.md',
    'webhook-endpoints': '/content/reference/webhook-endpoints.md',
    'sandbox-endpoints': '/content/reference/sandbox-endpoints.md',
    'changelog': './content/changelog/changelog.md',
    'help-center': './content/help/helpcenter.md'
}

// Cache to avoid re-fetching the same files
const contentCache = {};

// Extract title and subtitle from markdown
export const parseMetadata = (markdown) => {
  if (!markdown) return { title: 'Untitled', subtitle: '', content: markdown };
  
  const lines = markdown.split('\n');
  let title = 'Untitled';
  let subtitle = '';
  let contentStartIndex = 0;
  
  // Find first heading (# Title)
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line.startsWith('# ')) {
      title = line.replace('# ', '');
      contentStartIndex = i + 1;
      break;
    }
  }
  
  // Find first paragraph after title (subtitle)
  for (let i = contentStartIndex; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line && !line.startsWith('#') && !line.startsWith('```') && !line.startsWith('---')) {
      subtitle = line;
      break;
    }
  }
  
  return { title, subtitle, content: markdown };
};

// Fetch content for a specific page
export const getContent = async (pageId) => {
  // Check cache first
  if (contentCache[pageId]) {
    return contentCache[pageId];
  }

  const filePath = contentPaths[pageId];
  if (!filePath) {
    console.error(`No content path found for page: ${pageId}`);
    return null;
  }

  try {
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }
    const markdown = await response.text();
    const parsed = parseMetadata(markdown);
    
    // Cache the result
    contentCache[pageId] = parsed;
    
    return parsed;
  } catch (error) {
    console.error(`Error loading content for ${pageId}:`, error);
    return null;
  }
};

// Extract all H2 headings for Table of Contents
export const extractHeadings = (markdown) => {
  if (!markdown) return [];
  
  const lines = markdown.split('\n');
  const headings = [];
  
  lines.forEach(line => {
    const trimmed = line.trim();
    if (trimmed.startsWith('## ')) {
      const title = trimmed.replace('## ', '');
      const id = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      headings.push({ id, title });
    }
  });
  
  return headings;
};

